import { render } from "./Players.vue?vue&type=template&id=1bbfb9bc&scoped=true"
import script from "./players.js?vue&type=script&lang=js&external"
export * from "./players.js?vue&type=script&lang=js&external"

import "./Players.vue?vue&type=style&index=0&id=1bbfb9bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bbfb9bc"]])

export default __exports__